import React, { ReactNode, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import style from "./style.module.scss";
import "../../../index.scss";
import AdminToken from "../../AdminToken";
import AdminSperrmuelanmeldungen from "../../AdminSperrmuelanmeldungen";
import AdminCalendarData from "../../AdminCalendarData";
import AdminSchadstoffmobilStandorte from "../../AdminSchadstoffmobilStandorte";
import appConfig from "../../../util/appConfig";
import AdminCityParts from "../../AdminCityParts";
import AdminArticles from "../../AdminArticles";
import AdminPortalSettings from "../../AdminPortalSettings";
import AdminCreateUpdateArticle from "../../AdminCreateUpdateArticle";
import BlockedStreet from "../../AdminBlacklistStreets";
import AdminSperrmuelanmeldungInfo from "../../AdminSperrmuelanmeldungInfo";
import AdminCalendarDataItemInfo from "../../AdminCalendarDataItemInfo";
import WhiteListStreets from "../../AdminWhiteListStreets";
import GreyListStreets from "../../AdmimnGreyListStreets";
import AdminMailTracking from "../../AdminMailTracking";
import AdminObjectLogin from "../../AdminObjectLogin";
import AdminReclamation from "../../AdminReclamation";
import AdminBehaeltergemeinschaft from "../../AdminBehaeltergemeinschaft";
import AdminEigenkompostierer from "../../AdminEigenkompostierer";
import AdminBehaeltergemeinschaftInfoById from "../../AdminBehaeltergemeinschaftInfoById";
import AdminEigenkompostiererInfoById from "../../AdminEigenkompostiererInfoById";
import AdminReclamationById from "../../AdminReclamationById";
import AdminSepa from "../../AdminSepa";
import AdminSepaById from "../../AdminSepaById";
import AdminEigentuemerwechsel from "../../AdminEigentuemerwechsel";
import AdminEigentuemerwechselById from "../../AdminEigentuemerwechselById";
import AdminBehaelterverwaltung from "../../AdminBehaelterverwaltung";
import AdminBehaelterverwaltungById from "../../AdminBehaelterverwaltungById";
import AdminZusatzleisung from "../../AdminZusatzleisung";
import AdminZusatzleisungById from "../../AdminZusatzleisungById";
import { useAppDispatch, useAppSelector } from "../../../store";
import { getAdminNotificationItemsCount } from "../../../store/slices/app";
import AdminUsers from "../../AdminUsers";
import AdminUserById from "../../AdminUserById";
import AdminEwg from "../../AdminEwg";
import AdminEwgById from "../../AdminEwgById";
import AdminTonneDefekt from "../../AdminTonneDefekt";
import AdminTonneDefektById from "../../AdminTonneDefektById";
import AdminTonneVerschwunden from "../../AdminTonneVerschwunden";
import AdminTonneVerschwundenById from "../../AdminTonneVerschwundenById";
import AdminSperrmüllRegeln from "../../AdminSperrmelllRegeln";

const AdminMain = () => {
  const dispatch = useAppDispatch();

  const { role, isTokenValid } = useAppSelector((state) => state.admin);

  const isAdmin = ["SUPERADMIN", "ADMIN"].includes(role);

  useEffect(() => {
    dispatch(getAdminNotificationItemsCount());

    const interval = setInterval(() => {
      if (["lra", "calw", "mags"].includes(appConfig.logo)) {
        dispatch(getAdminNotificationItemsCount());
      }
    }, 60 * 1000);

    return () => {
      clearInterval(interval);
    };
    // }
  }, []);

  const routesConfig = [
    {
      link: "/sperrmuell-anmeldungen",
      component: AdminSperrmuelanmeldungen,
      isActive: true,
    },
    {
      link: "/sperrmuell-anmeldungen/:itemId",
      component: AdminSperrmuelanmeldungInfo,
      isActive: true,
    },
    {
      link: "/calendar-data/:itemId",
      component: AdminCalendarDataItemInfo,
      isActive: false,
    },
    {
      link: "/calendar-data",
      component: AdminCalendarData,
      isActive: false,
    },
    {
      link: "/create-token",
      component: AdminToken,
      isActive: true,
    },
    {
      link: "/schadstoffmobil/standorte",
      component: AdminSchadstoffmobilStandorte,
      isActive: false,
    },
    {
      link: "/city-parts",
      component: AdminCityParts,
      isActive: ["bk", "awl"].includes(appConfig.logo),
    },
    {
      link: "/articles",
      component: AdminArticles,
      isActive: ["sensis"].includes(appConfig.logo),
    },
    {
      link: "/articles/create",
      component: AdminCreateUpdateArticle,
      isActive: ["sensis"].includes(appConfig.logo),
    },
    {
      link: "/articles/update/:id",
      component: AdminCreateUpdateArticle,
      isActive: ["sensis"].includes(appConfig.logo),
    },
    {
      link: "/blocked-streets",
      component: BlockedStreet,
      isActive: true,
    },
    {
      link: "/white-list-streets",
      component: WhiteListStreets,
      isActive: ["ebwo", "lra", "calw", "mags", "leverkusen"].includes(
        appConfig.logo,
      ),
    },
    {
      link: "/grey-list-streets",
      component: GreyListStreets,
      isActive: ["ebwo", "lra", "calw", "mags", "leverkusen"].includes(
        appConfig.logo,
      ),
    },
    {
      link: "/portal-settings",
      component: AdminPortalSettings,
      isActive: true,
    },
    {
      link: "/mail-tracking",
      component: AdminMailTracking,
      isActive: isAdmin,
    },
    {
      link: "/objekt-login",
      component: AdminObjectLogin,
      isActive: ["lra", "calw", "mags"].includes(appConfig.logo),
    },
    {
      link: "/reclamation",
      component: AdminReclamation,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/reclamation/:itemId",
      component: AdminReclamationById,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/behaeltergemeinschaft",
      component: AdminBehaeltergemeinschaft,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/behaeltergemeinschaft/:itemId",
      component: AdminBehaeltergemeinschaftInfoById,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/eigenkompostierer",
      component: AdminEigenkompostierer,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/eigenkompostierer/:itemId",
      component: AdminEigenkompostiererInfoById,
      isActive: ["calw"].includes(appConfig.logo),
    },
    {
      link: "/sepa",
      component: AdminSepa,
      isActive: ["lra", "calw", "viersen"].includes(appConfig.logo),
    },
    {
      link: "/sepa/:itemId",
      component: AdminSepaById,
      isActive: ["lra", "calw", "viersen"].includes(appConfig.logo),
    },
    {
      link: "/eigentuemerwechsel",
      component: AdminEigentuemerwechsel,
      isActive: ["lra", "mags", "viersen"].includes(appConfig.logo),
    },
    {
      link: "/eigentuemerwechsel/:itemId",
      component: AdminEigentuemerwechselById,
      isActive: ["lra", "mags", "viersen"].includes(appConfig.logo),
    },
    {
      link: "/behaelterverwaltung",
      component: AdminBehaelterverwaltung,
      isActive: ["lra", "calw"].includes(appConfig.logo),
    },
    {
      link: "/behaelterverwaltung/:itemId",
      component: AdminBehaelterverwaltungById,
      isActive: ["lra", "calw"].includes(appConfig.logo),
    },
    {
      link: "/zusatzleisung",
      component: AdminZusatzleisung,
      isActive: ["lra"].includes(appConfig.logo),
    },
    {
      link: "/zusatzleisung/:id",
      component: AdminZusatzleisungById,
      isActive: ["lra"].includes(appConfig.logo),
    },
    {
      link: "/users",
      component: AdminUsers,
      isActive: ["lra", "calw", "mags", "leverkusen"].includes(appConfig.logo),
    },
    {
      link: "/users/new-user",
      component: AdminUserById,
      isActive:
        ["lra", "calw", "mags", "leverkusen"].includes(appConfig.logo) &&
        isAdmin,
    },
    {
      link: "/users/:id",
      component: AdminUserById,
      isActive:
        ["lra", "calw", "mags", "leverkusen"].includes(appConfig.logo) &&
        isAdmin,
    },
    {
      link: "/ewg",
      component: AdminEwg,
      isActive: ["awl"].includes(appConfig.logo),
    },
    {
      link: "/ewg/:id",
      component: AdminEwgById,
      isActive: ["awl"].includes(appConfig.logo),
    },
    {
      link: "/tonne-defekt",
      component: AdminTonneDefekt,
      isActive: ["viersen"].includes(appConfig.logo),
    },
    {
      link: "/tonne-defekt/:id",
      component: AdminTonneDefektById,
      isActive: ["viersen"].includes(appConfig.logo),
    },
    {
      link: "/tonne-verschwunden",
      component: AdminTonneVerschwunden,
      isActive: ["viersen"].includes(appConfig.logo),
    },
    {
      link: "/tonne-verschwunden/:id",
      component: AdminTonneVerschwundenById,
      isActive: ["viersen"].includes(appConfig.logo),
    },
    {
      link: "/sperrmuell-regeln",
      component: AdminSperrmüllRegeln,
      isActive: ["leverkusen", "mags"].includes(appConfig.logo),
    },
  ];

  return (
    <div className={style.wrapper}>
      <Sidebar />
      <div className={style.mainBodyWrapper}>
        <Routes>
          {routesConfig
            .filter((el) => el.isActive)
            .map((el) => {
              const Cmpt = el.component;
              return <Route path={el.link} element={<Cmpt />} key={el.link} />;
            })}
        </Routes>
      </div>
    </div>
  );
};

export default AdminMain;
